export default "__VITE_ASSET__oPfXHJeG__";